<template>
  <div class="look-error">
    <div class="exam-topic">
      <div class="exam-topic-type">{{question[0].HeadLine}}题</div>
      <div class="exam-topic-title">{{question[0].Title}}</div>
      <div class="exam-topic-choose" v-for="(data,i) in question[0].answerArr" :key="i">
        <span :class="ClassChoose(i)" v-show="data">{{String.fromCharCode(i + 65)}}</span>
        <span>{{data}}</span>
      </div>
    </div>
    <div class="look-error-explain">
      您的答案：
      <span>{{question[0].Answer}}</span>
      正确答案：
      <span style="color:#1095fc">{{question[0].rightkey}}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      question: [
        {
          HeadLine: ""
        }
      ],
      choosed: []
    };
  },
  mounted() {
    this.getMsg();
  },
  methods: {
    getMsg() {
      this.axios
        .get("./api/Index/GetAnswerrecord", {
          params: {
            id: this.$route.query.id
          }
        })
        .then(e => {
          if (e.data.code == 0) {
            this.question = e.data.History;
            this.question.forEach((item, i) => {
              this.question[i].answerArr = [];
              Object.keys(item).filter(names => {
                if (names.indexOf("C") > -1) {
                  this.question[i].answerArr.push(item[names]);
                }
              });
            });
            if (this.question[0].rightkey.indexOf(",") > -1) {
              let rightKeyArr = this.question[0].rightkey.split(",");
              rightKeyArr.filter(item => {
                this.choosed.push(item.charCodeAt() - 65);
              });
            } else {
              this.choosed.push(this.question[0].rightkey.charCodeAt() - 65);
            }
          }
        });
    },
    ClassChoose(i, data) {
      if (this.choosed.includes(i)) {
        return "correct";
      }

      let chooseNums = this.question[0].Answer.charCodeAt() - 65;

      if (i == chooseNums) {
        return "error";
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.look-error {
  &-explain {
    text-align: center;
    line-height: 3;
    background: #f9f9f9;
    width: 60%;
    margin: 0 auto;
  }
  .exam-topic {
    &-choose {
      .error {
        background: #f41717;
        color: #fff;
      }
      .correct {
        background: linear-gradient(
          -70deg,
          rgba(16, 149, 252, 1) 0%,
          rgba(72, 174, 253, 1) 99%
        );
        color: #fff;
      }
      span {
        &:nth-child(1) {
          display: inline-block;
          text-align: center;
          border-radius: 50%;
          width: 0.5rem;
          box-shadow: 0px 0.02rem 0.08rem 0px rgba(204, 204, 204, 1);
          height: 0.5rem;
        }
        margin-right: 0.4rem;
      }
      margin-top: 0.3rem;
      color: #000;
      background: #fff;
      display: flex;
      align-items: center;
    }
    &-title {
      line-height: 2;
    }
    &-type {
      display: inline-block;
      background: linear-gradient(
        1deg,
        rgba(249, 185, 77, 1),
        rgba(253, 203, 118, 1)
      );
      border-radius: 0.16rem 0.16rem 0.16rem 0.02rem;
      padding: 0.05rem 0.1rem;
      color: #fff;
    }
    background: #fff;
    margin-top: 0.2rem;
    padding: 0.2rem;
    min-height: 6rem;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
  background: #fff;
  height: 100vh;
}
</style>  